<template>
  <a-modal
    class="mood-light-modal"
    :title="`${title}心情灯`"
    :width="780"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 5 }"
      :wrapperCol="{ span: 18 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="设备ID" prop="serialNo">
        <a-input v-model="form.serialNo" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="设备编号" prop="deviceId">
        <a-input v-model="form.deviceId" placeholder="请输入设备编号" />
      </a-form-model-item>
      <a-form-model-item label="所属类型">
        <div class="flex-between">
          <j-dict-select-tag
            placeholder="请选择年级"
            v-model="form.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            allowClear
            style="width: 31%"
            @select="
              () => {
                $set(form, 'classId', '')
                $set(form, 'studentId', '')
              }
            "
            @clear="
              () => {
                $set(form, 'classId', '')
                $set(form, 'studentId', '')
              }
            "
          />
          <j-dict-select-tag
            placeholder="请选择班级"
            v-model="form.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!form.gradeId ? -1 : form.gradeId)
            "
            :disabled="!form.gradeId"
            :isShowEmpty="false"
            style="width: 31%"
            @select="$set(form, 'studentId', '')"
            @clear="$set(form, 'studentId', '')"
          />
          <j-dict-select-tag
            placeholder="请选择学生"
            v-model="form.studentId"
            class="search-space"
            :disabled="!form.classId"
            :dictCode="'student_info,name,id,class_id=' + (!form.classId ? -1 : form.classId)"
            style="width: 31%"
            :async="true"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item label="颜色状态设置">
        <div style="flex-wrap: wrap">
          <div v-for="(item, index) in form.configList" :key="index" class="flex-align-center">
            <div
              :style="{
                width: '18px',
                height: '18px',
                background: item.color,
                borderRadius: '50%',
              }"
            ></div>
            <div style="margin-left: 10px">{{ item.moodLamp }}</div>
            <!--取色器-->
            <color-picker v-model="item.color" @change="(color) => changeColor(color, item)">
              <div style="margin-left: 20px; color: #4a90e2; cursor: pointer">+自定义</div>
            </color-picker>
            <div style="margin: 0 15px">{{ descList[index] }}</div>
            <!--<a-input v-model="item.minVal" addon-after="%" style="flex: 1" />-->
            <!--<a-input v-model="item.maxVal" addon-after="%" style="flex: 1" />-->
            <a-input-group class="flex-align-center" style="flex: 1" compact>
              <a-input-number
                v-model="item.minVal"
                placeholder="最小值"
                style="width: 100px; text-align: center"
              />
              <a-input
                style="width: 30px; border-left: 0; pointer-events: none; background-color: #fff"
                placeholder="~"
                disabled
              />
              <a-input-number
                v-model="item.maxVal"
                placeholder="最大值"
                style="width: 100px; text-align: center; border-left: 0"
              />
              <span style="margin-left: 10px">%</span>
            </a-input-group>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="预警提醒周期设置" prop="warnPeriod">
        <a-radio-group v-model="form.warnPeriod">
          <a-radio v-for="(item, index) in warnCycleSetList" :key="index" :value="item.value">
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from '@api/manage'
import WangEditor from '@comp/WangEditor/index.vue'
import { isDateGreaterThanToday } from '@/utils/util'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'
import ColorPicker from '@comp/ColorPicker/index.vue'

const configList = [
  {
    moodLamp: '阳光积极',
    color: '#F8E71C',
    // desc: '高于昨日情绪阈值',
    minVal: 30,
    maxVal: 100,
  },
  {
    moodLamp: '平和稳定',
    color: '#24C55F',
    // desc: '对比昨日情绪阈值',
    minVal: -20,
    maxVal: 20,
  },
  {
    moodLamp: '情绪低落',
    color: '#A955F7',
    // desc: '对比昨日情绪阈值',
    minVal: -50,
    maxVal: -20,
  },
  {
    moodLamp: '急需关注',
    color: '#F53F3F',
    // desc: '低于昨日情绪阈值',
    minVal: -50,
    maxVal: -100,
  },
]

export default {
  name: 'MoodLighModal',
  components: {
    JMultiSelectTag,
    WangEditor,
    ColorPicker,
  },
  data() {
    return {
      title: '',
      color1: '#3498db',
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 8 },
      itemWrapperCol: { span: 15 },
      visible: false,
      warnCycleSetList: [
        {
          label: '实时提醒',
          value: 1,
        },
        {
          label: '按天提醒',
          value: 2,
        },
        {
          label: '按周提醒',
          value: 3,
        },
        {
          label: '按月提醒',
          value: 4,
        },
      ],
      form: {},
      descList: ['高于昨日情绪阈值', '对比昨日情绪阈值', '对比昨日情绪阈值', '低于昨日情绪阈值'],
      tabList: [
        {
          tab: '心理测评',
          key: '0',
        },
        {
          tab: '校园活动',
          key: '1',
        },
      ],
      rules: {
        serialNo: [{ required: true, message: '请输入设备ID', trigger: 'change' }],
        deviceId: [{ required: true, message: '请输入设备编号', trigger: 'change' }],
        warnPeriod: [{ required: true, message: '请选择预警提醒周期', trigger: 'change' }],
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.visible = true
      this.$set(this.form, 'configList', JSON.parse(JSON.stringify(configList)))
    },
    edit(data) {
      this.visible = true
      this.getMoodLampById(data.id)
    },
    // 获取对应心情灯信息
    async getMoodLampById(id) {
      const res = await getAction('/moodLamp/getMoodLamp', { id })
      const { success, result } = res
      if (success) {
        this.form = result
      }
    },
    changeColor(color, item) {
      this.$set(item, 'color', color.hex)
    },
    hideModal() {
      this.visible = false
      this.form = {}
      // 清除参数验证
      this.$refs.ruleForm.clearValidate()
    },
    async handleOk() {
      this.form.userIdentity = this.form.studentId
        ? 4
        : this.form.classId
        ? 3
        : this.form.gradeId
        ? 2
        : 1
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        let res = {}
        if (this.form?.id) {
          res = await putAction(`/moodLamp/updateMoodLamp`, this.form)
        } else {
          res = await postAction(`/moodLamp/addMoodLamp`, this.form)
        }
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('refreshData', this.form)
          this.hideModal()
          return
        }
        this.$message.error(res.message)
      })
    },
  },
}
</script>
<style scoped lang="less">
.scope-assessment {
  /deep/ .ant-select {
    max-height: 80px !important;
    overflow-y: auto !important;
  }
}
.mood-light-modal {
  ///deep/ .ant-modal-header {
  //  border-bottom: none;
  //}
  ///deep/ .ant-modal-body {
  //  padding: 10px 20px;
  //}
  /deep/ .ant-modal-header {
    padding: 10px 24px;
  }
}
</style>
